import Vue from "vue";
import { mapGetters } from "vuex";

import { LoadingSpinner } from "@/components";

import { formatDateTime, stringHelper } from "@/components/mixins";
import { ErrorLogService, GridUtil, PartDetailServices } from "@/services";
import DnTable from "@/components/Elements/DnTable/DnTable.vue";

export default Vue.extend({
    name: "OrderHistoryTab",

    components: {
        LoadingSpinner,
        DnTable
    },
    mixins: [formatDateTime, stringHelper],
    computed: {
        ...mapGetters(["user", "getContentItem", "hasPermission", "activeAccountId", "availableDealerCodes"]),
    },

    props: {
        oemPartCode: {
            type: String,
            default: "",
        },
    },

    created() {
        this.orderColumns = GridUtil.localizeColumnLabels(this.orderColumns, this.getContentItem);
        this.invoiceColumns = GridUtil.localizeColumnLabels(this.invoiceColumns, this.getContentItem);
    },

    data: () => ({
        orderColumns: [
            { key: "OrderNumber", label: "Order Number" },
            { key: "DealerPurchaseOrder", label: "PO Number" },
            { key: "OrderDate", localizationKey: "Date", formatter: "getLocalDate" },
        ],
        invoiceColumns: [
            { key: "InvoiceNumber", localizationKey: "InvoiceNumber" },
            { key: "SalesOrderNumber", label: "Order Number" },
            { key: "InvoiceDate", localizationKey: "Date", formatter: "getLocalDate" },
        ],
        orders: [],
        invoices: [],
        loadingOrders: false,
        loadingInvoices: false,
        haveSuccessfullyLoadedOrders: false,
        haveSuccessfullyLoadedInvoices: false
    }),

    methods: {
        async getOrders() {
            try {
                this.loadingOrders = true;

                const params = {
                    accountId: this.activeAccountId,
                    userId: this.user.UserId,
                    oemPartCode: this.oemPartCode,
                    stockFacingWarehouse: ""
                };

                var dealerCodes = [this.user.DealerCode];
                const data = await PartDetailServices.getOrderHistoryOrdersByOemPartCode(params, dealerCodes);
                this.orders = Array.isArray(data) ? data : [];
                this.haveSuccessfullyLoadedOrders = true;
            } catch (err) {
                ErrorLogService.LogException(err);
                return [];
            } finally {
                this.loadingOrders = false;
            }
        },
        async getInvoices() {
            try {
                this.loadingInvoices = true;

                const params = {
                    accountId: this.activeAccountId,
                    userId: this.user.UserId,
                    oemPartCode: this.oemPartCode,
                    stockFacingWarehouse: ""
                };

                var dealerCodes = [this.user.DealerCode];      
                const data = await PartDetailServices.getOrderHistoryInvoicesByOemPartCode(params, dealerCodes);
                this.invoices = Array.isArray(data) ? data : [];
                this.haveSuccessfullyLoadedInvoices = true;
            } catch (err) {
                ErrorLogService.LogException(err);
                return [];
            } finally {
                this.loadingInvoices = false;
            }
        },
        loadTabData(){
            if(!this.haveSuccessfullyLoadedOrders && !this.loadingOrders){
                this.getOrders();
            }
            if(!this.haveSuccessfullyLoadedInvoices && !this.loadingInvoices){
                this.getInvoices();
            }
        }
    },
});
